export const HANDLEABLE_ERROR_CODES = [
  1001115, // duplicated campaign
  1005102, // invalid url
];
